















import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";
import ImagePreview from "@/components/ImagePreview";

export default defineComponent({
  name: "PayeeInfoPreview",
  components: { BaseIcon, ImagePreview },
  props: {
    imageSrc: { type: String },
    name: { type: String },
  },
});
